<template>
  <div class="button-connect" :class="$mq">
    <BaseButton
        class="test-button-big"
        :class="$mq"
        name="login_button"
        @click="openBBB"
    >
      <i class="us us-computer us-2x us-fw" />
      <span class="mr-2">{{ $t("header.signin") }}</span>
    </BaseButton>
    <BaseButton
        class="test-button-white"
        :class="$mq"
        name="login_button"
        @click="openHelp"
    >
      <i class="nv nv-interface-question-mark nv-2x nv-fw" />
      <span class="mr-2">{{ $t("header.help") }}</span>
    </BaseButton>
  </div>
</template>

<script>
import BaseButton from "../BaseButton"

export default {
  name: "connect",

  components: {
    BaseButton,
  },

  data() {
    return {
      proto: process.env.VUE_APP_PROTO_BACK,
      BBB: process.env.VUE_APP_BBB,
      docBBB: process.env.VUE_APP_DOC_BBB,
    }
  },

  methods: {
    openBBB() {
      window.open(this.BBB, "_self")
    },

    openHelp() {
      window.open(this.docBBB, "_self")
    },

  }
}
</script>

<style lang="scss">
@import "../../utilities/variables";

.button-connect.smartphone {
  flex-direction: column;
  text-align: center;
  align-items: center;
  margin: 20px 0;
}

.button-connect {
  display: flex;
  //justify-content: flex-end;
}

.test-button-big.smartphone {
  max-width: 20rem;
}

.test-button-big {
  font-family: "Unistra A";
  padding: 4px 15px;
  text-align: center;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12em;

  cursor: pointer;
  letter-spacing: .03em;
  font-size: 1.20rem;

  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;

  background-color: $button-color-blue;
  color: $text-button-color;

  border-color: transparent;
  line-height: 1.8461538462;
  border-radius: 0px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  /*&-selected {
    background-color: darken($button-color-blue, 5%);
  }*/
  &:hover {
    background-color: darken($button-color-blue, 10%);
    font-weight: 700;
  }
}

.test-button-white.smartphone {
  max-width: 20rem;
}

.test-button-white {
  font-family: 'Unistra A';
  margin: 0 auto;
  padding: 5px 8px;
  text-align: center;
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12em;

  cursor: pointer;
  letter-spacing: .03em;
  font-size: 1.125rem;
  //min-width: 2.375rem;

  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;

  background-color: white;
  color: $button-color-blue;

  border-color: $button-color-blue;
  line-height: 1.8461538462;
  border-radius: 0px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  /*&-selected {
    background-color: darken($text-button-color, 5%);
  }*/
  &:hover {
    background-color: lighten($button-color-blue, 42%);
    font-weight: 600;
    /*color: $text-button-color;*/
  }
}
</style>
